export const PROFILE_PREVIEW_LOADING = 'PROFILE_PREVIEW_LOADING';
export const PROFILE_PREVIEW_SUCCESS = 'PROFILE_PREVIEW_SUCCESS';
export const PROFILE_PREVIEW_FAILED = 'PROFILE_PREVIEW_FAILED';
export const SAVE_PROFILE_PREVIEW_LOADING = "SAVE_PROFILE_PREVIEW_LOADING";
export const SAVE_PROFILE_PREVIEW_SUCCESS = "SAVE_PROFILE_PREVIEW_SUCCESS";
export const SAVE_PROFILE_PREVIEW_FAILED = "SAVE_PROFILE_PREVIEW_FAILED";